import type { Trade, TradeType } from '@root/entities/trade'

const TRADE_TYPE_ROW_COLOR_MAP: Record<TradeType.TradeType, string> = {
  buy: 'var(--up-9)',
  sell: 'var(--down-9)',
  poolInit: 'var(--neutral-9)',
  liquidityAdd: 'var(--up-9)',
  liquidityRemove: 'var(--down-9)',
  poolMigrate: 'var(--up-9)',
  quoteBurn: 'var(--amber-9)',
  lpBurn: 'var(--neutral-9)',
}

export const getTradeTypeRowColor = (tradeType: TradeType.TradeType) => {
  return TRADE_TYPE_ROW_COLOR_MAP[tradeType]
}

export const getTradeTableRowStyle = (row: Trade.Trade) => {
  const styles = {
    '--row-color': TRADE_TYPE_ROW_COLOR_MAP[row.type],
  } as React.CSSProperties

  if (row.type === 'liquidityRemove') {
    styles.background = 'var(--downA-1)'
  }

  return styles
}
